<template>
  <div class="explain">
    <button style="font-size: 20px" @click="backToPan()">
      {{ $t('explainList.back') }}
    </button>
    <div v-for="(palace, palaceId) in palaceData" :key="palaceId">
      <div v-if="starList(palace.stars).length > 0">
        <div class="title">
          {{ $t(palace.palaceName)
          }}<span v-if="palaceId != 0">{{ $t('gong') }}</span>
        </div>
        <div v-for="(star, index) in starList(palace.stars)" :key="index">
          <div class="star-link" @click="toExplain(star.name, palaceId)">
            《{{ $t(star.name) }}入{{ $t(palace.palaceName)
            }}<span v-if="palaceId != 0">{{ $t('gong') }}</span
            >解說》
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const MAIN = [
  '紫微',
  '天机',
  '太阳',
  '武曲',
  '天同',
  '廉贞',
  '天府',
  '太阴',
  '贪狼',
  '巨门',
  '天相',
  '天梁',
  '七杀',
  '破军',
]
export default {
  props: {
    palace: {
      type: String,
    },
  },
  data: function () {
    return {
      main: MAIN,
    }
  },
  beforeRouteEnter(to, from, next) {
    if ('palace' in to.params) {
      next()
    } else {
      next({ name: 'Home' })
    }
  },
  computed: {
    palaceData() {
      return JSON.parse(this.palace).sort((a, b) => a.palaceId - b.palaceId)
    },
  },
  methods: {
    backToPan: function () {
      this.$router.push({
        name: 'Home',
      })
    },
    toExplain: function (star, palaceId) {
      this.$router.push({
        name: 'Explain',
        params: { palace: this.palace, star: star, palaceId: palaceId },
      })
    },
    starList: function (stars) {
      let list = []
      for (let star of stars) {
        if (MAIN.includes(star.name)) {
          list.push(star)
        }
      }
      return list
    },
  },
}
</script>
<style scoped>
.explain {
  padding: 30px 0;
}
.title {
  font-size: 24px;
  padding: 30px 0;
  font-weight: bolder;
}
.star-link {
  color: #3484fc;
  font-size: 24px;
  line-height: 2;
}
</style>
